<template>
  <div class="card">
    <div class="card-body">
      <!-- Nav tabs -->
      <!-- <div class="row mb-3">
        <div class="col-sm-3">
          <multiselect
            v-model="filters.status"
            label="name"
            track-by="value"
            :options="filters.statusOptions"
            :searchable="false"
            :close-on-select="false"
            :show-labels="false"
            :allow-empty="false"
            placeholder="Կարգավիճակ"
          />
        </div>
      </div> -->
      <!-- Tab panes -->
      <div class="row">
        <div class="col-12 tenders-list">
            <v-server-table
              ref="vtable"
              :url="`${proxyUrl}contract/getByClient`"
              :options="options"
              :columns="columns"
              @loaded="({data}) => onLoaded(data)"
              @row-click="({row}) => {row.organize.status !== 'finished' && $modal.show('suggestion-modal', {...row, resetComponent})}"
            >
              <div slot="index" class="d-flex justify-content-center" slot-scope="{row, index}">
                  {{ index }}
              </div>
              <div slot="participant_name" class="d-flex justify-content-center" slot-scope="{row}">
                  {{ row.participant.name }}
              </div>
              <div slot="participant_name" class="d-flex justify-content-center" slot-scope="{row}">
                  {{ row.participant.name }}
              </div>
              <div slot="total_price" class="d-flex justify-content-center" slot-scope="{row}">
                  {{ row.price }}դր.
              </div>
              <div slot="total_leftover" class="d-flex justify-content-center" slot-scope="{row}">
                  {{ parseFloat(getContractLeftover(row).toFixed(2)) }}դր.
              </div>
              <div slot="delete" class="d-flex justify-content-center">
                <i class="mdi mdi-delete text-danger" style="font-size: 30px; cursor: pointer;"></i>
              </div>
              <div slot="contract" class="d-flex justify-content-center" slot-scope="{row}">
                {{consoleLog(row.lots.length)}}
                <button
                  @click="() => { 
                    $modal.show('contract-document-modal', {contract: row, resetComponent}) 
                  }"
                  v-if="row.participant.contract_document"
                  type="button" 
                  class="btn btn-primary btn-sm"
                >
                  <i class="fas fa-file-alt mr-1" />Պայմանագիր
                </button>
              </div>
              <div slot="order_input" class="d-flex justify-content-center" slot-scope="{row}">
                  <div class="row">
                    <div
                      class="p-0"
                      v-tooltip="!row.is_sign && 'Պայմանագիրը դեռ չի հաստատվել մասնակցի կողմից'"
                    >
                      <button
                        @click="() => { 
                          $modal.show('order-modal', {contract: row, resetComponent}) 
                        }"
                        :disabled="!row.is_sign"
                        type="button" 
                        class="btn btn-primary btn-sm"
                      >
                        Կատարել պատվեր
                      </button>
                    </div>
                  </div>
              </div>
            </v-server-table>
        </div>
        <order-modal />
        <order-details-modal />
        <specification-modal />
        <contract-document-modal />
        <!-- end col -->
      </div>
    </div>
  </div>
</template>

<script>
  import OrderModal from './modals/OrderModal'
  import SpecificationModal from '@/components/modals/SpecificationModal'
  import OrderDetailsModal from './modals/OrderDetailsModal'
  import ContractDocumentModal from '@/components/modals/ContractDocumentModal'

  export default {
    name: 'contracts',
    data() {
      return {
        proxyUrl: process.env.VUE_APP_API_URL,
        columns: ['index', 'code', 'participant_name', 'sign_date', 'total_price', 'total_leftover', 'contract', 'order_input'],
        options: {
          sortable: [],
          requestFunction(data) {
            return this.$client.get(this.url, {params: data})
            .catch(function (e) {this.dispatch('error', e)})
          },
          columnsDropdown: false,
          pagination: { chunk: 1 },
          filterByColumn: false,
          dateColumns: ['create_date','end_date'],
          skin: 'table table-hover',
          // sortable: ['cpvs_count', 'code', 'type', 'customer', 'category', 'status', 'end_date'],
          dateFormat: "YYYY-mm-dd",
          headings: {
            index: 'Հ/Հ',
            contract: '',
            code: 'Պայմանագրի ծածկագիր',
            participant_name: 'Մատակարարի անվանում',
            sign_date: 'Կնքման ամսաթիվ',
            total_price: 'Ընդհանուր արժեք',
            total_leftover: 'Ընդհանուր մնացորդ ըստ պատվերների',
            final_date: 'Վերջնաժամկետ',
            order_input: '',
          },
          texts: {
            count: 'Ցուցադրված է {from}֊ից {to}֊ը ընդհանուր {count} տողից|{count} տող|',
            first: 'Առաջին',
            last: 'Վերջին',
            filter: '',
            filterPlaceholder: 'Փնտրել',
            limit: '',
            page: 'Page:',
            noResults: 'Համընկնում չի գտնվել',
            noRequest: 'խնդրում ենք ընտրել առնվազն մեկ ֆիլտեր տվյալները ներբեռնելու համար',
            filterBy: 'փնտրել ըստ {column}',
            loading: 'Բեռնվում է...',
            defaultOption: 'ընտրել {column}',
            columns: 'Ընտրել դաշտերը',
          },
          filterable: true,
        },
        filters: {
          status: { name: 'Բոլորը', value: 'all' },
          statusOptions: [
            { name: 'Բոլորը', value: 'all' },
            { name: 'Ակտիվ առաջարկներ', value: 'active' },
            { name: 'Ավարտված առաջարկներ', value: 'finished' },
          ],
        }
      }
    },
    components: {OrderModal, SpecificationModal, OrderDetailsModal, ContractDocumentModal},
    computed: {
      locale() {
        return this.$store.getters['user/locale']
      },
      me() {
        return this.$store.getters['user/me']
      },
    },
    mounted() {
      // const contractId = this.$route.params.id
      // console.log(contractId)
      // if(contractId){
      //   console.log(this.$refs.vtable)
      // }
      // 
    },
    methods: {
      consoleLog(data){
        console.log(data)
      },
      onLoaded({data}){
        const contractId = this.$route.params.id
        if(contractId){
          const contract = data.find(item => item.id === +contractId)
          this.$modal.show('order-modal', {contract: contract})
        }
      },
      getContractLeftover(row){
        const { lots } = row
        var leftover = 0;
        lots.forEach((lot) => {
          const count = lot.available + lot.supplied + lot.ordered;
          const priceUnit = lot.price / count
          leftover += +lot.available * priceUnit
        })
        return leftover;
      },
      async resetComponent() {
        await this.$refs.vtable.refresh()
      },
    },
  }
</script>